import React from "react";
import styled from "styled-components";
import bgAction from "../../../../../assets/images/Event-2025/button-bg.png";
import iconHoa from "../../../../../assets/images/Event-2025/icon-hoa.png";
import { useSelector } from "react-redux";
import { curStateAccount } from "../../../../../Redux/selector";

export default function ButtonAction({
  isPrize = false,
  contentBtn,
  action = () => {},
  isActiveButton
}) {
  const selectorAccount = useSelector(curStateAccount);
  return (
    <Container>
      <img
        src={bgAction}
        alt=""
        className={`bg-btn ${
          !isPrize && selectorAccount.userInfo && isActiveButton ? "scale-hover-item" : "disable-btn-prize"
        } ${isActiveButton && selectorAccount.userInfo ? "" : "disable-button"}`}
        onClick={selectorAccount.userInfo && isActiveButton ? action : () => {}}
      />
      <div>
        <img src={iconHoa} alt="" className="hoa-1" />
        <img src={iconHoa} alt="" className="hoa-2" />
        <div className="content-btn-event">{contentBtn}</div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  z-index: 10;
  top: -90px;
  width: max-content;
  max-width: 100%;
  margin: 0 auto;

  .disable-button{
    cursor: no-drop;
  }

  .bg-btn {
    margin: 0 auto;
    text-align: center;
    align-items: center;
    display: flex;
    max-width: calc(100% - 20px);
  }

  .content-btn-event {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 30px;
    color: white;
    font-weight: bold;
    width: max-content;
    pointer-events: none;
  }

  .hoa-1 {
    position: absolute;
    z-index: 98;
    width: 40px;
    top: -14px;
    left: 50px;
  }

  .hoa-2 {
    position: absolute;
    z-index: 98;
    right: 42px;
    bottom: -35px;
  }

  .disable-btn-prize {
    cursor: no-drop;
    opacity: 0.7;
  }

  @media (min-width: 992px) {
    .disable-btn-prize {
      cursor: no-drop;
    }
  }

  @media (max-width: 576px) {
    .hoa-2 {
      width: 45px;
      bottom: -18px;
    }

    .hoa-1 {
      width: 30px;
    }

    .content-btn-event {
      font-size: 24px;
    }

    .bg-iso {
      height: 175px;
    }
  }
`;
